// "Build an order" tab.
import type { ReactNode } from 'react';
import { TabPlaceholder } from './TabPlaceholder.js';
import type { ActionRequestBody } from '../api/types.js';

// Reserved for the future call: fireAction('SHOPIFY_CREATE_DRAFT_ORDER', body).
export type BuildOrderCall = ActionRequestBody;

export function BuildOrder(): ReactNode {
  return (
    <TabPlaceholder
      tabName="Build an order"
      wiringNotes="Composes a Shopify draft order via POST /v1/actions/SHOPIFY_CREATE_DRAFT_ORDER, then completes it via SHOPIFY_COMPLETE_DRAFT_ORDER. Bundle pricing comes from services/sales-bundle-pricing."
    />
  );
}
